export default () => ({
  updateModal: null,
  imageModal: null,
  MonitorModal: null,
})
